<template>
    <div v-if="isVerifiedUser" class="mb-3" :class="sizeClassObject">
            <div class="card h-100">
                <div class="card-header">
                    <h5 class="card-title">{{$t('home.myLastPaticipations')}}</h5>
                </div>
                <div class="card-body">
                    <div v-if="myParticipations.length">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" class="w-50">{{$t('home.event')}}</th>
                                    <th scope="col">{{$t('home.participation')}}</th>
                                    <th scope="col">{{$t('home.startTime')}}</th>
                                    <th scope="col">{{$t('home.endTime')}}</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in myParticipations" :key="'myEvents'+index">
                                    <th scope="row">{{index+1}}</th>
                                    <td>{{item.eventName}}</td>
                                    <td>{{item.participationType}}</td>
                                    <td>{{$moment(item.eventStartDate).format('DD MMM YYYY')}}</td>
                                    <td>{{$moment(item.eventEndDate).format('DD MMM YYYY')}}</td>
                                    <td>
                                        <router-link :to="{ path: `/registers/events/edit/${item.registerEntityId}`}" replace :title="$t('buttons.open')">
                                            <i class="fa fa-external-link-alt"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <span class="text-danger">{{$t('home.noData')}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <router-link :to="{ path: '/account?tab=participantsTab'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
                </div>
            </div>
        </div>
</template>

<script>
    import { Role } from '../../helpers/role';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                myParticipations: [],
            }
        },
        computed: {
            isVerifiedUser() {
                return this.$store.getters.userRoles.includes(Role.VerifiedUser)
                    || this.$store.getters.userRoles.includes(Role.Participant);
            },
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.size);
            },
        },
        methods: {
            loadParticipations() {
                this.$http
                    .get('api/Participant/UsersParticipations')
                    .then(result => {
                        this.myParticipations = result.data;
                    })
                    .catch(err => console.log(err));
            }
        },
        mounted() {
            this.loadParticipations();
        }
    }
</script>
